<template>
    <section class="gmp-section gmp-mb-l">

        <div class="subpage-hero">
            <div class="two-column-tout">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6 h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                提升销售额
                            </h1>
                            <div class="h-u-mb-std two-column-tout__description">
                                <p>
                                    通过拼单功能，企业能够吸引更多客户参与订单，特别是那些原本可能因为订单金额不足而放弃购买的客户。
                                    拼单活动鼓励群体购买行为，推动更多订单的生成，从而提升整体销售额。
                                </p>
                            </div>

                        </div>

                        <div class="h-c-grid__col  h-c-grid__col-l--6  h-c-grid__col--align-middle">
                            <div class="two-column-tout__image text-center">
                                <picture>
                                    <img src="@/assets/img/pindan.png" alt="" class="gmp-no-grab ">
                                </picture>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>


    </section>
</template>

<script>
    export default {
        name: "PICK_subpagehero"
    }
</script>

<style lang="less">


</style>